// extracted by mini-css-extract-plugin
export default {"success":"styles---success---MWoF5","error":"styles---error---kyKLD"};